import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

export const DEFAULT_PROFILE_PICTURE = `${STATIC_STORAGE_URL}/usr/dc2a9fef-f28a-49d1-8ce4-61789ca8e51a_2b7cd9bb-19d9-4040-9b2f-08d71b34536b_download.png`;
export const DEFAULT_GREETING_IMAGE = `${STATIC_STORAGE_URL}/rbcgp/hello.gif`;
